import page from './page';
import service from './service';
import caseStudy from './caseStudy';
import faq from './faq';
import siteSettings from './siteSettings';
import testimonial from './testimonial';

export const schemaTypes = [
  // Document types
  siteSettings,
  page,
  service,
  caseStudy,
  faq,
  testimonial,
];
